<template>
  <div id="sideSiteNav">
    <ul id="smallNav" class="sidenav sidenav-fixed" ref="mainSideNav">
      <li class="searchLi">
        <div class="searchbar input-field">
          <input
            type="text"
            class="autocomplete"
            placeholder="Search Menu"
            name="filter"
            id="filter"
          />
        </div>
      </li>
      <li v-for="(item, index) in navItems" :key="index" v-show="_userView(item.canView)">
        <router-link :class="item.class" :to="{...item.to}">
          <i class="material-icons no-active" v-text="item.icon">home</i>{{item.title}}
        </router-link>
      </li>
      <ul class="collapsible collapsible-accordion" ref="collapse" v-if="authStatus">
      <!--   <li v-if="false">
          <a class="collapsible-header">
            <i class="material-icons-outline">person_pin</i> Training</a>
          <div class="collapsible-body">
            <ul>
              <li>
                <router-link
                  to="/category/liberty-digital-court-recording?id=33">
                  Liberty Digital Court Recording
                </router-link>
              </li>
              <li>
                <router-link to="/category/zoom-video-conference?id=34">
                  Zoom Video Conference
                </router-link>
              </li>
              <li>
                <router-link to="/category/e-litigation?id=37">
                  E-Litigation
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li v-if="authStatus">
            <router-link  class="sidenav-close waves-effect" :to="{name:'evaluations'}">
              <i class="material-icons">rate_review</i>Evaluations
            </router-link>    
        </li> -->
        <li v-for="(option, index) in expandableNavItems" :key="index"  v-show="_userView(option.canView)">
             <a class="collapsible-header">
              <i class="material-icons" v-text="option.icon"></i> {{option.title}}</a>
              <div class="collapsible-body">
                <li v-for="n in option.children" :key="n.id">
                <router-link
                  class="sidenav-close waves-effect"
                  :to="{...n.to}">
                  <i class="material-icons" v-text="n.icon"></i>{{n.title}}
                </router-link>
              </li>
              </div>
        </li>
<!--         <li v-if="authStatus">
          <a class="collapsible-header"
            ><i class="material-icons">article</i> Transcripts</a>
          <div class="collapsible-body">
            <ul>
              <li>
                <router-link
                  class="sidenav-close waves-effect"
                  :to="{ name: 'transcriptsLists' }">
                  <i class="material-icons">quiz</i>Incoming Requests
                </router-link>
              </li>
              <li>
                <router-link
                  class="sidenav-close waves-effect"
                  :to="{ name: 'transcripts'}">
                  <i class="material-icons">receipt</i>Transcript Requests
                </router-link>
              </li>
            </ul>
          </div>
        </li>
        <li v-if="authStatus">
          <a class="collapsible-header"><i class="material-icons">local_library</i> Library</a>
          <div class="collapsible-body">
              <li>
                <router-link
                  class="sidenav-close waves-effect"
                  :to="{ name: 'library' }">
                  <i class="material-icons">website</i>Library Portal
                </router-link>
              </li>
                          <li>
                <router-link
                  class="sidenav-close waves-effect"
                  :to="{ name: 'loans' }">
                  <i class="material-icons">website</i>Loans
                </router-link>
              </li>
          </div>
        </li>
        <li v-if="authStatus">
          <a class="collapsible-header">
            <i class="material-icons">content_paste</i>Records</a>
          <div class="collapsible-body">
            <li
              v-if="
                (userMeta.role === 'admin' && authStatus) ||
                (userMeta.role === 'superuser' &&
                  userMeta.department === 'it' &&
                  authStatus) ||
                (userMeta.department === 'records' && authStatus)">
              <router-link
                class="sidenav-close waves-effect"
                :to="{ name: 'records'}">
                Correspondence Database
              </router-link>
            </li>
            <li>
              <router-link
                class="sidenav-close waves-effect"
                :to="{ name: 'reportsView' }">
                Reports
              </router-link>
            </li>
          </div>
        </li>-->
      </ul>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import M from "materialize-css";
const initSideNavComponent = (element, options) => {
  const instance = M.Sidenav.init(element, options);
  return instance;
};
const initCollapse = (element, options) => {
  return M.Collapsible.init(element, options);
};
export default {
  name: "mainNav",
  props: {
    navStatus: {
      type: String,
      default: "close",
    },
    authStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let vm = this;
    return {
      navItems:[
        {
          title:'Home',
          icon: 'home',
          to:{name: 'home'},
          canView: ['it', 'hr', 'sec',],
          class:'no-active'
        },
      /*   {
          title:'Your Profile',
          icon: 'person',
          to:{name:'userProfile'},
          canView: ['it', 'hr', 'sec'],
          class:''
        }, */
        {
          title: "Transcript Request",
          icon:'dynamic_form',
          to:{name:'transcriptRequest'},
          canView: ['public'],
          class:''
        },
        {
          title: "Statistics",
          icon:'auto_graph',
          to:{path:'/stats'},
          canView: ['jud', 'it', 'sec', 'stats'],
          class:''
        }
      ],
      expandableNavItems:[
        {
          title: "Stats Dashboard",
          icon:'analytics',
          canView: ['it', 'hr', 'stats'],
          children:[
            {
                id: 99,
                title: "Submissions",
                icon:'send',
                to:{ name: 'StatsDashboard' },
                class:''
            }
          ]
        },
        {
            title: "Transcripts",
            icon:'article',
            canView: ['it', 'hr', 'sec'],
            children:[
              {
                id: 1,
                title: "Incoming Requests",
                icon:'quiz',
                to:{ name: 'transcriptsLists' },
                class:''
              },
              {
                id: 2,
                title: "Transcript Requests",
                icon:'receipt',
                to:{ name: 'transcripts'},
                class:''
              },
            ]
        },
       /*  {
        icon:"local_library",
        title:"Library",
        canView:['it',],
          children:[
            {
              id: 4,
              title: "Library Portal",
              icon:'local_library',
              to:{ name: 'library' },
              class:''
            },
            {
              id: 5,
              title: "Loans",
              icon:'south_east',
              to:{ name: 'loans' },
              class:''
            },
          ]
        }, */
      {
        icon:"document_scanner",
        title:"Records",
        canView:['it', 'records '],
          children:[
            {
              id: 6,
              title: "Correspondence Database",
              icon:'inventory_2',
              to:{ name: 'records'},
              class:''
            },
           /*  {
              id: 5,
              title: "Reports",
              icon:'leaderboard',
              to:{ name: 'reportsView' },
              class:''
            }, */
          ]
        }
      ],
      nav:{
        instance: null,
        options: {
          accordianInstance: "",
          preventScrolling: false,
          onOpenEnd: () => {
            vm.$emit("status", "opened");
          },
          onCloseStart: () => {
            vm.$emit("status", "closing");
          },
          onCloseEnd: () => {
            vm.$emit("status", "closed");
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    userMeta: {
      get() {
        return this.user && this.user.id
          ? { role: this.user.acf.role, department: this.user.acf.departments }
          : { role: "", department: null };
      },
    },
  },
  watch: {
    authStatus:function(nV){
      if(nV) {
        setTimeout(() => {
            this.$_initNavInstace();
        }, 100);
      }
    },
    navStatus: function (nV) {
      nV && nV === "open"
        ? this.nav.instance.open()
        : nV && nV === "close"
        ? this.nav.instance.close()
        : false;
    },
  },
  mounted() {
    this.$_initNavInstace();
  },
  beforeDestroy() {
    try {
      this.nav.instance.close();
      this.nav.instance.destroy();
    } catch (err) {
      window.console.warn(err);
    }
  },
  methods: {
    _userView(v){
      if (v.includes('public')) return true
      return v.includes(this.userMeta.department)
    },
    $_initCollapse() {
      this.accordianInstance = initCollapse(this.$refs.collapse);
    },
    $_initNavInstace() {
      this.nav.instance = initSideNavComponent(
        this.$refs.mainSideNav,
        this.nav.options
      );
      setTimeout(() => {
        this.$_initCollapse();
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
#smallNav {
  height: calc(100vh - 56px);
  top: 56px;
  z-index: 996;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02),
    0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02) !important;
  li {
    a {
      height: 48px;
      line-height: 48px;
      font-size: 15px;
      font-weight: 400;
      padding: 0 16px;
      i {
        height: 48px;
        margin-right: 12px;
        line-height: 48px;
      }
    }
  }
  .collapsible {
    li {
      position: relative;
      a.collapsible-header {
        &::after {
          font-family: "Material Icons";
          font-size: 20px;
          right: 12px;
          top: 0px;
          position: absolute;
          content: "expand_more";
        }
      }
      &.active {
        a.collapsible-header {
          &::after {
            content: "expand_less";
          }
        }
      }
    }
    .collapsible-body {
      li {
        a {
          padding-left: 32px;
        }
      }
    }
  }
}
.router-link-active:not(.no-active) {
  background: #3d5afe !important;
  color: white !important;
  i {
    color: white !important;
  }
}
</style>

<style lang="scss">
.sidenav-overlay {
  top: 56px;
  opacity: 0.2 !important;
  z-index: 993;
}
.searchbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 4px 0;
  height: 58px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  input[type="text"] {
    line-height: 24px;
    font-size: 14px;
    border: none !important;
    box-shadow: none;
    border-radius: 3px;
    height: 36px;
    width: 80%;
    padding: 0 6%;
    background: rgba(217, 217, 217, 0.18);
    margin: 0 4% 20px;
  }
}
</style>